import React, { useState,useEffect } from 'react';
import {
    IonPage,
    IonContent,
    IonGrid,
    IonRow,
    IonCol,
    IonButton,
    IonIcon, IonLoading
} from '@ionic/react';
import { eye, eyeOff } from 'ionicons/icons';
import appLogo from '../theme/images/logo-big.png';
import { useHistory } from "react-router";
import {actionToLoginUserViaLoginEmailPhoneAndPass} from "../apiHelpers/CommonAction";
import useStore from "../zustand/useStore";

const LoginPage = ({renderHeaderPage}) => {
    const [emailOrPhone, setEmailOrPhone] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({});
    const history = useHistory();
    const {setSignupSigninError,signupSigninError,userAuthDetail} = useStore();

    const goToPage = (page) => {
        history.replace(page);
    };

    const handleLogin = () => {
        const errs = {};

        if (!emailOrPhone.trim()) {
            errs.emailOrPhone = 'Email or Phone number is required';
        }

        setErrors(errs);

        if (Object.keys(errs).length === 0) {
            actionToLoginUserViaLoginEmailPhoneAndPass(emailOrPhone, password);
        }
    };

    useEffect(()=>{
        if (signupSigninError?.error && signupSigninError?.message){
            if (signupSigninError?.error === 'phone'){
                const errs = {};
                errs.emailOrPhone = signupSigninError?.message;
                setErrors(errs);
            } else {
                const errs = {};
                errs.password = signupSigninError?.message;
                setErrors({...errs});
            }
        }else{
            setErrors({});
        }
    },[signupSigninError])

    useEffect(()=>{
        setPassword('');
        setEmailOrPhone('');
        setShowPassword('');
        setSignupSigninError({});
        setErrors({})
    },[])

    return (
        <IonPage>
            {renderHeaderPage && renderHeaderPage()}
            <IonContent fullscreen className="login-content">
                <IonGrid className="login-grid">
                    <IonRow>
                        <IonCol size="12" className="ion-text-center">
                            <img
                                src={appLogo}
                                alt="CA World"
                                className="login-logo"
                            />
                        </IonCol>

                        <IonCol size="12">
                            <div className="login-group">
                                <label className="login-label">Enter Email ID / Phone number</label>
                                <input
                                    type="text"
                                    className="login-input"
                                    placeholder="Email ID / Phone Number"
                                    value={emailOrPhone}
                                    onChange={(e) => setEmailOrPhone(e.target.value)}
                                />
                                {errors.emailOrPhone && <p className={"danger_error_text"} color="danger">{errors.emailOrPhone}</p>}
                            </div>
                        </IonCol>

                        <IonCol size="12">
                            <div className="login-group">
                                <label className="login-label">Enter Password</label>
                                <div className="input-wrapper">
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        className="login-input"
                                        placeholder="Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <IonIcon
                                        icon={showPassword ? eyeOff : eye}
                                        className="toggle-password"
                                        onClick={() => setShowPassword(!showPassword)}
                                    />
                                </div>
                                {errors.password && <p className={"danger_error_text"} color="danger">{errors.password}</p>}
                            </div>
                        </IonCol>

                        <IonCol size="12">
                            <IonButton
                                expand="block"
                                className="login-button"
                                onClick={handleLogin}
                            >
                                Login
                            </IonButton>
                        </IonCol>
                        <IonCol size="12" className="ion-text-center login-links">
                            <p className="login-link-text forgot-pass-link" onClick={() => goToPage('/forgot-password')}>Forgot Password?</p>
                            <p className="login-link-text or-sec">OR</p>
                            <p className="login-register" onClick={() => goToPage('/signup')}>Create New Account</p>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
            <IonLoading isOpen={userAuthDetail?.loading} className={"loading_loader_spinner_container"} message={"Please Wait..."}/>
        </IonPage>
    );
};

export default LoginPage;
